import { Box, MenuItem, TextField } from "@mui/material"
import { HelpOutlined } from "@mui-symbols-material/w300"
import type { FC } from "react"
import { Controller, useFormContext } from "react-hook-form"

import { TextFieldComponent } from "../TechnicalInformation/TechnicalInformationContent"

import { EndAdornmentSelect } from "@/components/TextFieldWithSelect/TextFieldWithSelect"
import { FIELD_LABEL_CLASSES } from "@/constants/forms"
import { LeadTimeUnits } from "@/graphql/codegen/graphql"
import { formatLeadTimeUnit } from "@/screens/Products/utils"

interface FormData {
  weightPerTruckload: number | null
  leadTimeInDays: number | null
  minOrderQuantity: number | null
  leadTimeDisplayUnits: LeadTimeUnits
}

export const ShippingDetailsContent: FC = () => {
  const { control } = useFormContext<FormData>()

  return (
    <form>
      <Box>
        <TextFieldComponent
          control={control}
          name='weightPerTruckload'
          label='Pounds (lb) per Truckload'
          placeholder='000'
          type='number'
        />
        <Controller
          name='leadTimeInDays'
          control={control}
          render={({ field, fieldState: { error } }) => (
            <Box className='mt-6'>
              <label className={FIELD_LABEL_CLASSES}>Lead Time</label>
              <TextField
                {...field}
                type='number'
                value={field.value}
                slotProps={{
                  input: {
                    endAdornment: (
                      <Box className='flex items-center gap-4'>
                        <HelpOutlined />
                        <Controller
                          name='leadTimeDisplayUnits'
                          control={control}
                          render={({ field }) => (
                            <EndAdornmentSelect selectField={field}>
                              {Object.values(LeadTimeUnits).map((uom) => (
                                <MenuItem key={uom} value={uom}>
                                  {formatLeadTimeUnit(uom)}
                                </MenuItem>
                              ))}
                            </EndAdornmentSelect>
                          )}
                        />
                      </Box>
                    ),
                  },
                  htmlInput: {
                    className: "hide-stepper",
                  },
                }}
                placeholder='00'
                fullWidth
                variant='outlined'
                helperText={error?.message}
                error={!!error}
              />
            </Box>
          )}
        />
        <TextFieldComponent
          control={control}
          name='minOrderQuantity'
          label='Min Order Qty (lb)'
          placeholder='00'
          type='number'
        />
      </Box>
    </form>
  )
}
